import imageCompression from 'browser-image-compression'

const compressImageWithMaxSizeMB = async (imgFile, maxSizeMB = 1) => {
  try {
    const compressedFile = await imageCompression(imgFile, maxSizeMB) // maxSizeMB, maxWidthOrHeight are optional
    return compressedFile
  } catch (err) {
    throw new Error(err)
  }
}

const compressImage = (file, quality = 0.7, maxWidth = 2000) =>
  new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      const img = new Image()
      img.onload = () => {
        // Resize canvas to maintain aspect ratio if needed
        let { width } = img
        let { height } = img

        if (width > maxWidth) {
          height = (height * maxWidth) / width
          width = maxWidth
        }

        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)

        // Compress to JPEG with given quality
        canvas.toBlob(
          (blob) => {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }))
          },
          'image/jpeg',
          quality,
        )
      }
      img.src = event.target.result
    }
    reader.readAsDataURL(file)
  })

const getFileSizeMB = (imgFile) => imgFile.size / 1024 / 1024

export { getFileSizeMB, compressImage }

export default compressImageWithMaxSizeMB
